(() => {
  if (window.BellyfulIngredientRoster) return;
  const init = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-ingredient-roster]')];
    if (scope.matches?.('[data-ingredient-roster]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (root.dataset.rosterReady === 'true') return;
      root.dataset.rosterReady = 'true';
      const items = [...root.querySelectorAll('[data-roster-item]')];
      const filters = root.querySelector('[data-roster-filters]');
      let job = 'all';
      const matchesProduct = (item) => !root.dataset.selectedProduct || item.dataset.products.split('|').includes(root.dataset.selectedProduct);
      const update = () => {
        let shown = 0;
        items.forEach((item) => {
          item.hidden = !matchesProduct(item) || (job !== 'all' && item.dataset.job !== job);
          if (!item.hidden) shown++;
          else {
            item.classList.remove('is-open');
            item.querySelector('.bf-roster-line__panel').inert = true;
            item.querySelector('.bf-roster-line__button')?.setAttribute('aria-expanded', 'false');
          }
        });
        root.querySelectorAll('[data-roster-visible]').forEach((element) => { element.textContent = shown; });
        root.querySelectorAll('[data-roster-visible-noun]').forEach((element) => { element.textContent = shown === 1 ? 'ingredient' : 'ingredients'; });
        filters?.querySelectorAll('[data-roster-filter]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.rosterFilter === job)));
      };
      const rebuild = () => {
        job = 'all';
        const selected = items.filter(matchesProduct);
        if (root.dataset.selectedProduct) {
          root.querySelectorAll('[data-roster-total]').forEach((element) => { element.textContent = selected.length; });
          root.querySelectorAll('[data-roster-noun]').forEach((element) => { element.textContent = selected.length === 1 ? 'ingredient' : 'ingredients'; });
          root.querySelectorAll('[data-roster-statement]').forEach((element) => { element.textContent = selected.length === 1 ? root.dataset.singular : root.dataset.plural; });
        }
        if (filters) {
          filters.querySelectorAll('[data-roster-filter]:not([data-roster-filter="all"])').forEach((button) => button.remove());
          const allCount = filters.querySelector('[data-filter-count="all"]');
          if (allCount) allCount.textContent = selected.length;
          const jobs = new Map();
          selected.forEach((item) => {
            if (!item.dataset.job) return;
            const entry = jobs.get(item.dataset.job) || { label: item.dataset.jobLabel, count: 0 };
            entry.count++;
            jobs.set(item.dataset.job, entry);
          });
          jobs.forEach((entry, key) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.rosterFilter = key;
            button.setAttribute('aria-pressed', 'false');
            button.append(document.createTextNode(`${entry.label} `));
            const count = document.createElement('b');
            count.textContent = entry.count;
            button.append(count);
            filters.append(button);
          });
        }
        update();
      };
      root.addEventListener('bellyful:product-selected', rebuild);
      root.addEventListener('click', (event) => {
        const filter = event.target.closest('[data-roster-filter]');
        if (filter && filters?.contains(filter)) { job = filter.dataset.rosterFilter; update(); }
        const button = event.target.closest('.bf-roster-line__button');
        if (!button || !root.contains(button)) return;
        const item = button.closest('.bf-roster-line');
        const open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(open));
        item.querySelector('.bf-roster-line__panel').inert = !open;
      });
      root.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-roster-item]');
        if (!item) return;
        if (!matchesProduct(item)) root.querySelectorAll('[data-product-choice]').forEach((button) => { if (item.dataset.products.split('|').includes(button.dataset.productChoice) && !matchesProduct(item)) button.click(); });
        job = 'all';
        update();
        if (!item.hidden) {
          item.classList.add('is-open');
          item.querySelector('.bf-roster-line__panel').inert = false;
          item.querySelector('.bf-roster-line__button').setAttribute('aria-expanded', 'true');
        }
      });
      rebuild();
    });
  };
  window.BellyfulIngredientRoster = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
